import * as svg from "../../../assets/chevron-down-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ChevronDownIcon = iconBuilder(svg, "ChevronDownIcon", "0 0 16 16");
